export default __webpack_public_path__ + "static/media/sleek-and-user-friendly.2dbea232.svg";